<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Detalle Recibo</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb />
          </nav>
        </div>
      </div>
    </base-header>

    <div v-if="order && receipt" class="container-fluid mt--6">
      <div class="row justify-content-center">
        <div class="col-12 card-wrapper">
          <div class="card">
            <div class="card-header">
              <div class="card-body">
                <order-info :receipt="receipt" :order="order" :edit="false" @get-quotation="setDollarQuotation" />

                <div>
                  <hr />

                  <concept-payment-list
                    v-if="hasItems"
                    class="mb-4"
                    :items="receipt.conceptPayments"
                    :edit="false"
                    @deleteItem="deleteItem"
                  />

                  <payment-detail v-if="receipt" class="mb-4" :receipt="receipt" />

                  <payment-by-months v-if="order && receipt" class="mb-4" :order="order" :receipt="receipt" />

                  <debt-info
                    class="mb-4"
                    :order-dollar-quote="order.dollarQuote"
                    :current-dollar-quote="currentDollarQuotation"
                    :debt-in-dollars="updatedDebtInDollars"
                    :debt-in-pesos="updatedDebtInOrderPesos"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import { subtract, divide } from '@/util/math';

import OrderInfo from './List/OrderInfo.vue';
import DebtInfo from './List/DebtInfo.vue';
import PaymentByMonths from './List/PaymentByMonths.vue';
import PaymentDetail from './List/PaymentDetail.vue';
import ConceptPaymentList from './List/ConceptPaymentList.vue';

export default {
  name: 'ReceiptShow',
  components: {
    OrderInfo,
    DebtInfo,
    PaymentByMonths,
    RouteBreadCrumb,
    ConceptPaymentList,
    PaymentDetail,
  },

  data() {
    return {
      order: null,
      receipt: null,
    };
  },

  computed: {
    ...mapGetters('dollarQuotation', ['currentDollarQuotation']),

    ...mapState('models/order', { orderDebt: 'debt' }),

    updatedDebtInDollars() {
      return this.getDebt(this.orderDebt.dollar, 'amountInDollars');
    },

    updatedDebtInPesos() {
      return this.getDebt(this.orderDebt.pesos, 'amountInPesos');
    },

    updatedDebtInOrderPesos() {
      return this.getDebt(this.orderDebt.pesosOrder, 'amountInPesos');
    },
  },

  async created() {
    await this.fetchReceipt();

    await this.fetchOrderDebt({
      orderId: this.receipt.orderId,
      dollarQuotation: this.receipt.dollarQuotation,
      receiptId: this.receipt.compliance ? this.receipt.id : null,
    });

    this.fetchOrder();

    this.addAmountInDollarToConceptPayments();
  },

  methods: {
    ...mapActions('models/order', ['fetchOrderDebt']),

    getDebt(total, prop) {
      const canceled = [...this.receipt.conceptPayments].reduce(
        (canceled, conceptPayment) => Number(canceled) + Number(conceptPayment[prop]),
        0
      );

      return subtract(total, canceled);
    },

    addAmountInDollarToConceptPayments() {
      if (this.receipt.conceptPayments.length > 0) {
        this.receipt.conceptPayments = this.receipt.conceptPayments.map((concept) => {
          const amountInDollars = divide(concept.amountInPesos, this.receipt.dollarQuotation);

          return {
            ...concept,
            amountInDollars,
          };
        });
      }
    },

    fetchOrder() {
      const params = {
        include: ['producer.distributor.seller', 'state'],
        append: ['total', 'total-in-pesos'],
      };

      this.$services
        .resource('orders')
        .show(this.receipt.orderId, params)
        .then((res) => res.data.data)
        .then((order) => (this.order = order));
    },

    fetchReceipt() {
      const params = {
        include: ['order.producer.distributor.seller', 'conceptPayments.conceptPaymentType'],
        append: ['total'],
      };

      return this.$services
        .resource('receipts')
        .show(this.$route.params.receiptId, params)
        .then((res) => res.data.data)
        .then((receipt) => (this.receipt = receipt));
    },
  },
};
</script>
